export const PATHS = {
  home: "/",
  gallery: "/gallery",
  pricing: "/pricing",
  login: "/login",
  signup: "/signup",
  checkYourEmail: "/check-your-email",
  forgotPassword: "/forgot-password",
  myPhotos: "/myphotos",
  settings: "/settings",
  uploadPhoto: "/upload-photo",
  termsOfUse: "/terms-of-service",
  privacyPolicy: "/privacy-policy",
  checkout: "/checkout",
  checkoutStatus: "/checkout-status",
  photo: "/photo",
  updatePayment: "/update-payment",
  paymentStatus: "/payment-status",
  adminConsole: "/admin",
};

export const NAVIGATION_STATE_KEYS = {
  comingFromRegistration: "comingFromRegistration",
};
